var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6597 2.10055L12.9982 19.6973L9.955 16.7001C7.67551 14.4552 3.98206 14.4576 1.70549 16.7061C-0.570763 18.9545 -0.568263 22.5971 1.7116 24.8419L9.30276 32.3179C11.7401 34.7184 15.7449 34.5238 17.9315 31.8993L36.6733 9.40537C38.7188 6.95062 38.3591 3.32534 35.87 1.30812C33.3806 -0.708797 29.705 -0.354067 27.6596 2.10067L27.6597 2.10055Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c084a157c7f370b02e402cc5b4be8f71.svg";
export { ForwardRef as ReactComponent };